module.exports = __webpack_public_path__ + "0d61a2b532489f1edc171ba6bbeba282.jpg";